
export function GameHeader() {
  return (
    <header className="text-center mb-2">
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Match My Logic: Daily</h1>
      <p className="text-sm sm:text-base text-gray-600 mt-0.5">
        {new Date().toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}
      </p>
    </header>
  );
}
